import { SubmitHandler, useForm } from 'react-hook-form';
import { StepProps } from '@pages/auth/register';
import { ChoosePassword, choosePasswordSchema } from '@interfaces/auth';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '@vibTheme/components/_base/Button';
import { InputPassword } from '@vibTheme/components/_base/Input';

export function ChoosePasswordStep({
  stateStorage,
  publish,
  isLoading,
}: StepProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ChoosePassword>({
    resolver: zodResolver(choosePasswordSchema),
  });

  const handleRegister: SubmitHandler<ChoosePassword> = async (data) => {
    publish({ ...stateStorage, ...data });
  };

  return (
    <form
      id="register-form-choosepassword"
      className="flex flex-col w-full text-left gap-main"
      onSubmit={handleSubmit(handleRegister)}
    >
      <InputPassword
        id="register-input-password"
        name="password"
        control={control}
        label="Senha"
        defaultValue={stateStorage?.password}
        placeholder="ex: Vibx12345"
        error={!!errors.passwordConfirmation}
        helperText={errors.passwordConfirmation?.message}
      />
      <InputPassword
        id="register-input-passwordconfirmation"
        name="passwordConfirmation"
        control={control}
        label="Confirmar Senha"
        defaultValue={stateStorage?.passwordConfirmation}
        placeholder="ex: Vibx12345"
        error={!!errors.passwordConfirmation}
        helperText={errors.passwordConfirmation?.message}
      />
      <Button
        id="register-button-submit-choosepassword"
        type="submit"
        loading={isLoading}
      >
        Criar Conta
      </Button>
    </form>
  );
}
